module.exports = __webpack_public_path__ + "assets/manual_safeCarAccident-530c91536ebcd452ecc5b8f2ee64f74c.pdf";